import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { SocioPipeModule } from '../pipes';

import { SocioTableComponent } from './socio-table.component';

@NgModule({
    imports: [
        SharedModule,
        SocioPipeModule
    ],
    declarations: [
        SocioTableComponent
    ],
    exports: [
        SocioTableComponent
    ]
})
export class SocioTableModule { }
